<template>
  <div class="procurement__cards">
    <p v-if="!isAuthorized" v-t="'form.public-search.authorization-required'"></p>
    <div class="procurement__col u-red-color font-weight-bold"
         v-if="item.hasCancelled"
         v-t="'form.public-search.item.lot-cancelled.label'">
    </div>
    <h3 class="procurement__title">{{item.name}}</h3>

    <div class="procurement__description">
      <div class="procurement__col">{{$t('labels.tender-number')}}:</div>
      <span>{{item.num | defaultValue($t('labels.tender-number-not-filled'))}}</span>

      <div class="procurement__col">{{$t('form.public-search.item.publish-date.label')}}:</div>
      <span>
        <date-time :value="item.published"></date-time>
      </span>
      <div class="procurement__col">{{$t('form.public-search.item.application-completion-date.label')}}: </div>
      <span>
        <date-time :value="item.endGettingReq"></date-time>
      </span>
      <div class="procurement__col">{{$t('form.public-search.item.number-of-lots.label')}}:</div>
      <span>
        {{item.countLot}}
      </span>
      <div class="procurement__col">{{$t('form.public-search.item.owner.label')}}:</div>
      <span>{{item | fullName}}</span>
    </div>
    <p class="a-input a-input--disabled"
       style="color:#E30613; text-align: center"
       v-if="item.invite">
      {{$t('form.public-search.item.invited.label')}}
    </p>

    <router-link class="gui-btn gui-btn--red gui-btn--order"
                 :to="{name: 'purchases-my-lots-details', params: { lotId: item.id, tab: 'overview'}}"
                 v-if="isAuthorized && item.countLot === 1"
                 v-t="'buttons.open-public-lot'">

    </router-link>

    <router-link class="gui-btn gui-btn--red gui-btn--order"
                 :to="{name: 'purchases-public-tender-details', params: { tenderId: item.id, tab: 'overview'}}"
                 v-if="isAuthorized && item.countLot > 1"
                 v-t="'buttons.open-public-lot'">
    </router-link>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },

      isAuthorized: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>

</style>
